import log2 from "../../js/log2-lite";
import bubble1 from "./bubble1";
import bubble2 from "./bubble2";
import bubble3 from "./bubble3";
import bubble4 from "./bubble4";
import bubble5 from "./bubble5";
import bubble6 from "./bubble6";
import bubble7 from "./bubble7";
import bubble8 from "./bubble8";
import bubble9 from "./bubble9";
import bubble10 from "./bubble10";
import bubble11 from "./bubble11";
import bubble12 from "./bubble12";
import bubble13 from "./bubble13";
import bubble14 from "./bubble14";
import bubble15 from "./bubble15";
import bubble16 from "./bubble16";
import bubble17 from "./bubble17";
import bubble18 from "./bubble18";
import bubble19 from "./bubble19";
import bubble20 from "./bubble20";
const log = log2("bubbles");
const BUBBLES = {
    BUBBLE_1: bubble1,
    BUBBLE_2: bubble2,
    BUBBLE_3: bubble3,
    BUBBLE_4: bubble4,
    BUBBLE_5: bubble5,
    BUBBLE_6: bubble6,
    BUBBLE_7: bubble7,
    BUBBLE_8: bubble8,
    BUBBLE_9: bubble9,
    BUBBLE_10: bubble10,
    BUBBLE_11:bubble11,
    BUBBLE_12:bubble12,
    BUBBLE_13:bubble13,
    BUBBLE_14:bubble14,
    BUBBLE_15:bubble15,
    BUBBLE_16:bubble16,
    BUBBLE_17:bubble17,
    BUBBLE_18:bubble18,
    BUBBLE_19:bubble19,
    BUBBLE_20:bubble20,
};

export default BUBBLES;

export function getBubble(index = "1", color = "#000") {
    log("getBubble", { index, color });
    if (index === "0") return { img: BUBBLES.BUBBLE_1(color), indexOfImg: index };
    else if (index === "1") return { img: BUBBLES.BUBBLE_1(color), indexOfImg: index };
    else if (index === "2") return { img: BUBBLES.BUBBLE_2(color), indexOfImg: index };
    else if (index === "3") return { img: BUBBLES.BUBBLE_3(color), indexOfImg: index };
    else if (index === "4") return { img: BUBBLES.BUBBLE_4(color), indexOfImg: index };
    else if (index === "5") return { img: BUBBLES.BUBBLE_5(color), indexOfImg: index };
    else if (index === "6") return { img: BUBBLES.BUBBLE_6(color), indexOfImg: index };
    else if (index === "7") return { img: BUBBLES.BUBBLE_7(color), indexOfImg: index };
    else if (index === "8") return { img: BUBBLES.BUBBLE_8(color), indexOfImg: index };
    else if (index === "9") return { img: BUBBLES.BUBBLE_9(color), indexOfImg: index };
    else if (index === "10") return { img: BUBBLES.BUBBLE_10(color), indexOfImg: index };
    else if (index === "11") return { img: BUBBLES.BUBBLE_11(color), indexOfImg: index };
    else if (index === "12") return { img: BUBBLES.BUBBLE_12(color), indexOfImg: index };
    else if (index === "13") return { img: BUBBLES.BUBBLE_13(color), indexOfImg: index };
    else if (index === "14") return { img: BUBBLES.BUBBLE_14(color), indexOfImg: index };
    else if (index === "15") return { img: BUBBLES.BUBBLE_15(color), indexOfImg: index };
    else if (index === "16") return { img: BUBBLES.BUBBLE_16(color), indexOfImg: index };
    else if (index === "17") return { img: BUBBLES.BUBBLE_17(color), indexOfImg: index };
    else if (index === "18") return { img: BUBBLES.BUBBLE_18(color), indexOfImg: index };
    else if (index === "19") return { img: BUBBLES.BUBBLE_19(color), indexOfImg: index };
    else if (index === "20") return { img: BUBBLES.BUBBLE_20(color), indexOfImg: index };
    else return { img: undefined, indexOfImg: index };
}



//////////////////
// WEBPACK FOOTER
// ./static/src/bubbles/index.js
// module id = null
// module chunks = 